import { atom } from 'recoil';
import { recoilPersist } from 'recoil-persist';
import Const from '../constant/Const';

const { persistAtom } = recoilPersist();

export const defaultValue = {
    macId: null,
    clientIp: null,
    tailNumber: null,
    origin: null,
    destination: null,
    clientId: null,
    domestic: false, //yurtiçi uçuş ise true değilse yurtdışı false. default false (yurtdışı)
    range: '' //SHORT veya LONG olabilir.
};

const flightAtom = atom({
    key: 'flight',
    default: defaultValue,
    effects_UNSTABLE: [persistAtom]
});

export const getFlight = () => {
    return JSON.parse(localStorage.getItem(Const.RECOIL_PERSIST) || null)?.flight || null;
};

export const getJWT = () => {
    return localStorage.getItem(Const.JWT) || null;
};

export const setJWT = (jwt) => {
    localStorage.setItem(Const.JWT, jwt);
};

export const getToken = () => {
    return localStorage.getItem('token') || null;
};

export const getTailNumber = () => {
    return JSON.parse(localStorage.getItem(Const.RECOIL_PERSIST) || null)?.flight?.tailNumber || null;
};

export const getDomestic = () => {
    return JSON.parse(localStorage.getItem(Const.RECOIL_PERSIST) || null)?.flight?.domestic;
};

export const getRange = () => {
    return JSON.parse(localStorage.getItem(Const.RECOIL_PERSIST) || null)?.flight?.range || null;
};

export const getDestination = () => {
    return JSON.parse(localStorage.getItem(Const.RECOIL_PERSIST) || null)?.flight?.destination || null;
};

export const getOrigin = () => {
    return JSON.parse(localStorage.getItem(Const.RECOIL_PERSIST) || null)?.flight?.origin || null;
};

export const setFlightId = (flightId) => {
    if (flightId !== undefined && flightId !== null)
        localStorage.setItem(Const.FLIGHT_ID, flightId);
};

export const getPanasonicLog = () => {
    let logs = localStorage.getItem(Const.PANASONIC_LOG) || null;
    if (logs === undefined || logs == null) {
        logs = [];
    } else logs = JSON.parse(localStorage.getItem(Const.PANASONIC_LOG));
    return logs;
};


export { flightAtom };
